module.exports = __webpack_public_path__ + "img/figure-14.5a7f3bba.png";